export default "__VITE_ASSET__ClZJm9sM__"